import React, { Component } from 'react'
import { connect } from '@cerebral/react'
import { state } from 'cerebral/tags'
import { css } from 'aphrodite'
import styles from './styles'
import getItemStyles from './getItemStyles'

const NodeDragLayerComp = connect(
  {
    currentNodeHover: state`node.currentNodeHover`
  },
  class NodeDragLayer extends Component {
    render() {
      const { isDragging, itemType } = this.props
      if (!isDragging || itemType !== 'NODE') {
        return null
      }
      return (
        <div className={css(styles.layerStyles)}>
          <div style={getItemStyles(this.props)}>
            <div className={css(styles.plusSymbol)}>{'+'}</div>
          </div>
        </div>
      )
    }
  }
)

export default NodeDragLayerComp



// WEBPACK FOOTER //
// ./src/components/Menu/NodeDragLayer/nodeDragLayer.js